'use strict';
module.exports = [
    '$compile',
    function($compile) {

        return {
            controller: ['$element', '$scope', yBlurCtrl],
            controllerAs: 'ctrl',
            scope: {
                yModel: '=yBlur'
            },
            restrict: 'A',
            compile: function(element) {
                element.removeAttr('y-blur'); // necessary to avoid infinite compile loop
                element.attr('ng-model', 'model');
                element.attr('ng-blur', 'ctrl.onBlur()');
                let fn = $compile(element);
                return function(scope){
                    fn(scope);
                };
            }
        };
    }];

class yBlurCtrl {
    constructor($element, $scope) {
        this.$element = $element;
        this.$scope = $scope;

        this.yObserveHandler = this.yObserver.bind(this);
        $scope.yModel.observe(this.yObserveHandler);

        $scope.model = $scope.yModel.toString();

        $scope.$on('$destroy', this.destroy.bind(this));
    }

    onBlur() {
        let length = this.$scope.yModel.toString().length;
        this.$scope.yModel.delete(0, length);

        let val = this.$scope.model;
        this.$scope.yModel.insert(0, val.toString());
    }

    yObserver(event) {
        if(event.type == 'insert') {
            this.$scope.$evalAsync(() => {
                this.$scope.model = event.object.toString();
            })
        }
    }

    destroy() {
        this.$scope.yModel.unobserve(this.yObserveHandler);
    }
}
